"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("jquery");
require("jszip");
require("datatables.net-dt");
require("datatables.net-buttons-dt");
require("datatables.net-buttons/js/buttons.colVis.js");
require("datatables.net-buttons/js/buttons.html5.js");
require("datatables.net-buttons/js/buttons.print.js");
require("datatables.net-responsive-dt");
require("datatables.net-select-dt");
var Help_1 = __importDefault(require("./Help"));
var moment = require("moment");
var ac_tables_1 = __importDefault(require("./ac.tables"));
require("datatables.net-buttons/js/dataTables.buttons.js");
//import 'datatables.net-buttons/js/buttons.html5.js';
//import 'datatables.net-buttons/js/buttons.print.js';  
// import the rest
$.fn.insertAt = function (elements, index) {
    var length = this.children().length;
    if (index === 0) {
        this.prepend(elements);
    }
    else if (index >= length) {
        this.append(elements);
    }
    else {
        var targetAtRequestedIndex = this.children().eq(index);
        targetAtRequestedIndex.before(elements);
    }
    return this;
};
var AcTablesHelp;
(function (AcTablesHelp) {
    function NullCoaleser(x, y) {
        if (x == 0) {
            return x;
        }
        else {
            return x || y;
        }
    }
    function _IsNull(x) {
        if (x == null) {
            return true;
        }
        else {
            return false;
        }
    }
    ;
    function getColFilterType(classNames) {
        var respVal = ColSearchTypes.Select;
        if (Help_1.default.stringContains("no_search", classNames)) {
            respVal = ColSearchTypes.NoSearch;
        }
        else if (Help_1.default.stringContains("search_text", classNames)) {
            respVal = ColSearchTypes.Text;
        }
        else if (Help_1.default.stringContains("search_date_range", classNames)) {
            respVal = ColSearchTypes.DateRange;
        }
        else if (Help_1.default.stringContains("search_bool", classNames)) {
            respVal = ColSearchTypes.Bool;
        }
        else if (Help_1.default.stringContains("search_num_range", classNames)) {
            respVal = ColSearchTypes.NumericalRange;
        }
        else if (Help_1.default.stringContains("search_multi_select", classNames)) {
            respVal = ColSearchTypes.MultiSelect;
        }
        return respVal;
    }
    AcTablesHelp.getColFilterType = getColFilterType;
    ;
    var ColSearchTypes;
    (function (ColSearchTypes) {
        ColSearchTypes[ColSearchTypes["Select"] = 1] = "Select";
        ColSearchTypes[ColSearchTypes["Text"] = 2] = "Text";
        ColSearchTypes[ColSearchTypes["DateRange"] = 3] = "DateRange";
        ColSearchTypes[ColSearchTypes["Bool"] = 4] = "Bool";
        ColSearchTypes[ColSearchTypes["NumericalRange"] = 5] = "NumericalRange";
        ColSearchTypes[ColSearchTypes["MultiSelect"] = 6] = "MultiSelect";
        ColSearchTypes[ColSearchTypes["NoSearch"] = 7] = "NoSearch";
    })(ColSearchTypes = AcTablesHelp.ColSearchTypes || (AcTablesHelp.ColSearchTypes = {}));
    function templateRender(data, argNames, template) {
        var respVal;
        var argValues = [];
        for (var i = 0; i < argNames.length; i++) {
            //console.log(`argName ${argNames[i]}`);
            if (!Help_1.default.isNullOrEmpty(data[argNames[i]])) {
                argValues.push(data[argNames[i]]);
                // console.log(`argName ${argNames[i]} val ${data[argNames[i]]}`);
            }
        }
        if (argValues.length === argNames.length) { //this check means we can inhibit the display render by having no val for one of the values - e.g. for RootOrgId on CPs this means can have OrgId or ParentOrgId as private for filtering, while inhibiting the creation of (erroneous) links for display and bad export values / global filter etc
            respVal = String_Format(template, argValues);
        }
        else {
            respVal = "";
        }
        return respVal;
    }
    /**
     * handles the outputs of Cell properly depending on diff requirements
     * @param data for the cell
     * @param type 'filter' | 'display' | 'type' | 'sort' | 'export' | 'private' (private is custom for filters etc)
     * @param fullRow full row data
     * @param meta contains additional information about the cell being requested.This object contains the following properties:
     * row - The row index for the requested cell.See row().index()
     * col - The column index for the requested cell.See column().index().
     * settings - The DataTables.Settings object for the table in question.This can be used to obtain an API instance if required.
     * @param colDef 'server side col def'
     */
    function advancedRender(data, type, fullRow, meta, colDef) {
        if (_IsNull(data)) {
            return "";
        }
        else {
            if (type === 'display') {
                //default
                var respVal = NullCoaleser(NullCoaleser(data.d, data.v), data);
                if (!Help_1.default.isNullOrUndef(colDef)) {
                    //console.log("colDef present");
                    if (!Help_1.default.isNullOrUndef(colDef.renderInfo)) {
                        respVal = templateRender(data, colDef.renderInfo.args, colDef.renderInfo.template);
                    }
                    else if (!Help_1.default.isNullOrUndef(colDef.conditionalInfo)) {
                        var valueAsKey = data[colDef.conditionalInfo.dataKey];
                        respVal = colDef.conditionalInfo.displays[valueAsKey];
                    }
                    else if (!Help_1.default.isNullOrUndef(colDef.conditionalRenderInfo)) {
                        var valueAsKey = data[colDef.conditionalRenderInfo.dataKey];
                        var template = colDef.conditionalRenderInfo.displayTemplates[valueAsKey];
                        var argNames = colDef.conditionalRenderInfo.args;
                        respVal = templateRender(data, argNames, template);
                    }
                }
                return respVal;
            }
            else if (type === 'filter') {
                return NullCoaleser(NullCoaleser(data.f, data.v), data);
            }
            else if (type === 'private') {
                return NullCoaleser(NullCoaleser(NullCoaleser(data.p, data.f), data.v), data); //Cool //console.log(`Getting private data '${data.P}' '${data.F}' '${data.V}' '${data}'`);
            }
            else if (type === 'extras') {
                return NullCoaleser(NullCoaleser(data.e, data.v), data); //Cool //console.log(`Getting private data '${data.P}' '${data.F}' '${data.V}' '${data}'`);
            }
            else if (type === 'sort') {
                //console.log("Got sort value of : " + data.s);
                var sTemp = NullCoaleser(NullCoaleser(data.s, data.v), data);
                //console.log("Returning : " + sTemp);
                return sTemp;
            }
            else if (type === 'type') {
                //if (!Help.isNullOrUndef(data.type)) {
                //    console.log("Got data.type of : " + data.type);
                //}
                //if (!Help.isNullOrUndef(data.Type)) {
                //    console.log("Got data.Type of : " + data.Type);
                //}
                return NullCoaleser(NullCoaleser(data.type, data.v), data); //This is for DT's type detection... not sure where data.Type comes from??? maybe DT generates it? Maybe it's a legacy thing? Or it's from the colDef??
            }
            else if (type === 'export') {
                return NullCoaleser(NullCoaleser(data.e, data.v), data);
            }
            else {
                return data;
            }
        }
    }
    AcTablesHelp.advancedRender = advancedRender;
    ;
    function String_Format(str, arr) {
        return str.replace(/\{([0-9]+)\}/g, function (_, index) { return arr[index]; });
    }
    function matchAsNumbers(valueToCompare, cellDataValueToCompare) {
        return (parseInt(valueToCompare, 10) === cellDataValueToCompare);
    }
    AcTablesHelp.matchAsNumbers = matchAsNumbers;
    function matchAsStrings(valueToCompare, cellDataValueToCompare) {
        return (valueToCompare.toString() === cellDataValueToCompare.toString());
    }
    AcTablesHelp.matchAsStrings = matchAsStrings;
    //TODO:TD might need moment here ?
    function compareAsDate_From(filterValue, cellValue) {
        var respVal = true;
        if (!Help_1.default.isNullOrUndef(filterValue)) {
            if (Help_1.default.isNullOrUndef(cellValue)) {
                respVal = false;
            }
            else {
                var filterDate = moment(filterValue, "DD/MM/YYYY");
                var cellDate = moment(cellValue, "YYYY/MM/DD");
                respVal = (filterDate <= cellDate);
            }
        }
        return respVal;
    }
    AcTablesHelp.compareAsDate_From = compareAsDate_From;
    function compareAsDate_To(filterValue, cellValue) {
        var respVal = true;
        if (!Help_1.default.isNullOrUndef(filterValue)) {
            if (Help_1.default.isNullOrUndef(cellValue)) {
                respVal = false;
            }
            else {
                var filterDate = moment(filterValue, "DD/MM/YYYY");
                var cellDate = moment(cellValue, "YYYY/MM/DD");
                respVal = (cellDate <= filterDate);
            }
        }
        return respVal;
    }
    AcTablesHelp.compareAsDate_To = compareAsDate_To;
    //cref:http://live.datatables.net/qitulequ/1/edit
    function _updateOperationButtons(e, settings) {
        //let tApi: DataTables.Api;
        //tApi.buttons(
        // I find that setting this to run after a 1 millisecond timeout to work for the dt.init event, otherwise, it doesnt seem to work...
        setTimeout(function () {
            // Create an API object of the associated table
            var dtApi = new $.fn.dataTable.Api(settings), rowCountAll = dtApi.rows().count(), // Get the count of ALL rows on the page
            rowCountPage = dtApi.rows({ page: 'current', search: 'applied' }).count(), // Get the count of the rows on the CURRENT page
            rowCountSelected = dtApi.rows({ selected: true, search: 'applied' }).count(), // Get the count of the selected rows
            dtBtns = {
                // Buttons that require selected rows to be enabled
                requireSelected: dtApi.buttons('.require-selected'),
                // Buttons that need to show the count of ALL rows
                addCountAll: dtApi.buttons('.show-count-all'),
                // Buttons that need to show the count of SELECTED rows
                addCountSelected: dtApi.buttons('.show-count-selected'),
                // Buttons that need to show the count of rows on CURRENT PAGE
                addCountPage: dtApi.buttons('.show-count-page'),
                // Buttons that need to show the count of SELECTED rows, or ALL if none are selected
                allOrSelected: dtApi.buttons('.show-all-or-selected')
            }, 
            /**
             * If the number provided is in the thousands, this will just add a comma where its needed
             *
             * param   {number|string}     num     Number (eg: 1234567)
             * returns {string}  Proper thousands result (eg: 12,34,567)
             */
            toThousands = function (num) {
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }, 
            /**
             * Update the label (or text) of a button, by appending a specified count of
             * rows to the buttons 'title' attribute
             *
             * param   {number}    rowCount    Count to show in button
             * param   {boolean}   hideZero    If this is true, and the row count is 0, then (0) wont be appended
             * note    The DT button MUST have the titleAttr property defined, as that is the $().prop('title') value
             */
            setBtnLabelCount = function (rowCount, hideIfZero) {
                rowCount = parseInt(rowCount);
                hideIfZero = !!hideIfZero;
                var btnPostTxt;
                if (hideIfZero === true && !rowCount)
                    btnPostTxt = '';
                else
                    btnPostTxt = ' ' + (rowCount > 0 ? '(' + toThousands(rowCount) + ')' : '(0)');
                return function (btn, index) {
                    dtApi.button(btn.node).text($(btn.node).prop('title') + btnPostTxt);
                };
            };
            // Buttons that need to show the selected rows, or all rows, if none are selected
            dtBtns.allOrSelected.each(setBtnLabelCount(rowCountSelected || rowCountAll));
            // Buttons that need to show the count of all rows
            dtBtns.addCountAll.each(setBtnLabelCount(rowCountAll));
            // Buttons that need to show the count of only selected rows
            dtBtns.addCountSelected.each(setBtnLabelCount(rowCountSelected, true));
            // Buttons that need to show the number of rows on the current page
            dtBtns.addCountPage.each(setBtnLabelCount(rowCountPage));
            // Buttons that should be disabled if no rows are selected
            dtBtns.requireSelected.enable(rowCountSelected > 0);
        }, 1);
    }
    AcTablesHelp._updateOperationButtons = _updateOperationButtons;
    ;
})(AcTablesHelp || (AcTablesHelp = {}));
exports.default = AcTablesHelp;
$.fn.dataTable.ext.pager.numbers_length = 5;
$.fn.dataTable.ext.pager.simple_numbers_no_ellipses = function (page, pages) {
    var numbers; //var numbers = [];
    var buttons = $.fn.dataTable.ext.pager.numbers_length;
    var half = Math.floor(buttons / 2);
    var _range = function (len, start) {
        var end;
        if (typeof start === "undefined") {
            start = 0;
            end = len;
        }
        else {
            end = start;
            start = len;
        }
        var out = []; //var out = [];
        for (var i = start; i < end; i++) {
            out.push(i);
        }
        return out;
    };
    if (pages <= buttons) {
        numbers = _range(0, pages);
    }
    else if (page <= half) {
        numbers = _range(0, buttons);
    }
    else if (page >= pages - 1 - half) {
        numbers = _range(pages - buttons, pages);
    }
    else {
        numbers = _range(page - half, page + half + 1);
    }
    numbers.DT_el = 'span';
    return ['first', 'previous', numbers, 'next', 'last'];
};
$.fn.dataTable.ext.search.push(
//settings, searchData, index, rowData, counter 
function (settings, searchDataForRow, rowIndex, fullDataForRow, searchIndex) {
    var respVal = true;
    var tableId = settings.nTable.id;
    if (tableId === "table_main") {
        var localSearchObject = ac_tables_1.default.getSearchObject(); //console.log(`rowIndex : ${rowIndex}`);
        if (!Help_1.default.isNullOrEmpty(localSearchObject)) {
            for (var key in localSearchObject) {
                var value = localSearchObject[key]; //console.log(`key ${key} value ${value}`);
                var fullDataForCell = fullDataForRow[key]; //var valueFromData = searchDataForRow[key]; did use this before - but we can do better !!!!
                var privateFilterData = ac_tables_1.default.getPrivateFilterData(fullDataForCell); //console.log(`got privateFilterData '${privateFilterData}' comparing with '${value}'`);
                if (!AcTablesHelp.matchAsNumbers(value, privateFilterData) && !AcTablesHelp.matchAsStrings(value, privateFilterData)) {
                    respVal = false;
                }
            }
        }
        var localRangeSearchObject = ac_tables_1.default.getRangeSearchObject();
        if (!Help_1.default.isNullOrEmpty(localRangeSearchObject)) {
            for (var key in localRangeSearchObject) {
                var valObj = localRangeSearchObject[key];
                var cellDataObj = fullDataForRow[key];
                var cellValue = ac_tables_1.default.getPrivateFilterData(cellDataObj);
                if (valObj.type === ac_tables_1.default.RangeTypes.Date) {
                    //console.log(`comparing dates with from ${valObj.from} - to ${valObj.to} for index ${key}`);
                    //if(!Help.isNullOrUndef(valObj.from)) {
                    if (!AcTablesHelp.compareAsDate_From(valObj.from, cellValue)) {
                        //console.log(`FALSE for compareAsDate_From ${valObj.from} vs ${cellValue}`);
                        respVal = false;
                    }
                    //}
                    //if (!Help.isNullOrUndef(valObj.to)) {
                    if (!AcTablesHelp.compareAsDate_To(valObj.to, cellValue)) {
                        //console.log(`FALSE for compareAsDate_To ${valObj.to} vs ${cellValue}`);
                        respVal = false;
                    }
                    //}
                }
            }
        }
    }
    return respVal;
});
//# sourceMappingURL=ac.tables.help.js.map